<template>
  <div class="editor-tool">
    <Upload :id="uploadId"
      ref="uploadElem"
      :action="action"
      name="file"
      :format="fileFormat"
      :data="tokenImg"
      :show-upload-list="false"
      :headers="headers"
      :max-size="5120"
      :on-progress="handleStart"
      :on-format-error="handleFormatError"
      :on-exceeded-size="handleImgMaxSize"
      :on-success="handleSuccess"
      :on-error="handleError"
    >
      <Button icon="ios-cloud-upload-outline">导入</Button>
    </Upload>
    <quill-editor 
           v-model="content"
           :options="editorOption"
           :ref="toref">
     </quill-editor>
  </div>
</template>

<script>
import StoreUtils from "@/utils/StoreUtils";
import conf from "@/views/im/conf";

import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css'; 
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export default {
  name: "upload-tool",
  props: {
    toref: {
      type: String,
      default:"quillEditor"
    },
  },
  data() {
    let self = this;
    return {
      uploadId: this.toref+'Upload',
      content: '',
      editorOption: {
        modules: {
          toolbar: {
            container: [
              [{size: []}],
              ['image']
            ],
            handlers: {
                'image': function (value) {
                    if (value) {
                        document.querySelector('#'+self.uploadId+' .ivu-btn').click()
                    } else {
                        this.quill.format('image', false);
                    }
                }
            }
          }
        }
      },
      imgFormat: ["jpg", "jpeg", "png", "gif"],
      fileFormat: [
        "doc",
        "docx",
        "jpg",
        "jpeg",
        "png",
        "gif",
        "xls",
        "xlsx",
        "pdf",
        "gif",
        "exe",
        "msi",
        "swf",
        "sql",
        "apk",
        "psd"
      ],
      tokenImg: {
      },
      tokenFile: {
        access_token: StoreUtils.getAccessToken(),
        type: "file"
      },
      action: conf.getHostUrl()+'/common/upload',
      headers: {
        token: StoreUtils.getToken()
      }
    };
  },
  components: {
    quillEditor
  },
  methods: {
    getEditorContent() {
      return this.content;
    },
    clearContent() {
      this.content = '';
    },
    beforeUpload() {
      this.tokenImg = {
      };
      this.tokenFile = {
        access_token: StoreUtils.getAccessToken(),
        type: "file"
      };
      return new Promise(resolve => {
        this.$nextTick(function() {
          resolve(true);
        });
      });
    },

    // 错误提示
    openMessage(error) {
      this.$Message.error(error);
    },

    handleStart() {
      this.$Loading.start();
    },
    handleFormatError(file) {
      this.$Message.warning("文件 " + file.name + " 格式不正确。");
    },
    handleImgMaxSize(file) {
      this.$Message.warning("图片 " + file.name + " 太大，不能超过 512K！");
    },
    handleFileMaxSize(file) {
      this.$Message.warning("文件 " + file.name + " 太大，不能超过 10M！");
    },
    handleSuccess(res) {
      // 获取富文本组件实例

      let toeval = "this.$refs."+this.toref+".quill"
      let quill = eval(toeval);
      // 如果上传成功
      if (res) {
          // 获取光标所在位置
          let length = quill.selection.savedRange.index;
          // 插入图片，res为服务器返回的图片链接地址
          quill.insertEmbed(length, 'image', res.data.url)
          // 调整光标到最后
          quill.setSelection(length + 1)
      } else {
          // 提示信息，需引入Message
          this.$Message.warning('图片插入失败')
      }
    },
    handleError: function() {
      this.$Loading.finish();
      this.$Message.error("上传错误！");
    }
  }
};
</script>

<style scoped>
.upload-tool {
  display: inline-block;
}
.ivu-upload {
    display: none;
}
</style>
